import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Input } from '../../components/Inputs/Input';
import { apiService } from '../../services/api';
import PlusLogo from '../../assets/plusLogo.svg';
import { Button } from '../../components/Button';
import { BoxForm } from '../../components/BoxForm';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { formRules } from '../../components/RegisterForm/FormRules';
import { useToast } from '../../hooks';
import { PUBLIC_ENV, ROUTES } from '../../utils/constants';

export interface IFormInput {
  email: string;
}

export const ResetPasswordPage = () => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const userFormDefaultValues: IFormInput = {
    email: '',
  };

  const methods = useForm<IFormInput>({
    defaultValues: userFormDefaultValues,
  });
  const { handleSubmit, reset } = methods;

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    setIsLoading(true);
    await apiService
      .forgotPassword({
        email: data.email,
        resetUrl: `${PUBLIC_ENV.APP_URL}${ROUTES.auth.newPass}`,
      })
      .then(() => {
        toast.success('Email enviado com sucesso!');
        reset();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex justify-center items-center w-full h-screen">
      <FormProvider {...methods}>
        <BoxForm
          className="shadow-xl p-8 rounded-[2.81rem] overflow-hidden max-w-xl w-4/5"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <img
            className="flex self-center h-[16rem] w-[16rem]"
            src={PlusLogo}
            alt="logo"
          />
          <Input
            label="E-mail"
            type="email"
            name="email"
            placeholder="exemplo@gmail.com"
            rules={formRules.emailRequired}
            startAdornment={
              <InputAdornment position="start">
                <AccountCircle style={{ color: '#122B87' }} />
              </InputAdornment>
            }
          />
          <span className="text-center font-roboto font-bold text-gray-900">
            <Link
              className="text-blue-primary no-underline"
              to={ROUTES.auth.login}
            >
              Voltar a tela de login
            </Link>
          </span>
          <Button
            type="submit"
            style={{
              color: '#122B87',
              fontWeight: '800',
              textTransform: 'none',
              borderRadius: '25px',
              padding: '.3rem',
            }}
            isLoading={isLoading}
          >
            REDEFINIR SENHA
          </Button>
        </BoxForm>
      </FormProvider>
    </div>
  );
};
